export default __webpack_public_path__ + "static/media/blackPipe.e7eb6b7e.png";